import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import Dict from "../../../helper/dict";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {DiscountContext} from "../../../context/discount_context";


const TABLE_HEAD = ["#", "کد", "درصد", "حداکثر مبلغ", "سقف ریالی", "انقضا", "نوع سرویس", "آخرین تغییر", "توضیحات", "وضعیت", "عملیات"];

export function DiscountGrid({
                               setSortBy,
                               sortType,
                               setSortType
                             }) {

  const {discounts, setDiscount, setModalOpen} = useContext(DiscountContext);
  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "id",
    "کد": "code",
    "درصد": "percentage",
    "حداکثر مبلغ": "max_value",
    "سقف ریالی": "max_value_usage",
    "انقضا": "expiration_date",
    "نوع سرویس": "type",
    "آخرین تغییر": "admin_name",
    "توضیحات": "description",
    "وضعیت": "status",
    "عملیات": "",
  }

  const headSortable = {
    "#": true,
    "کد": true,
    "درصد": true,
    "حداکثر مبلغ": true,
    "سقف ریالی": true,
    "انقضا": true,
    "نوع سرویس": true,
    "آخرین تغییر": true,
    "توضیحات": true,
    "وضعیت": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {discounts.map(
          ({
             id,
             type,
             code,
             percentage,
             max_value,
             max_value_usage,
             expiration_date,
             creator,
             agent_id,
             admin_name,
             description,
             status,
             updated_at,
           }, index) => {
            const isLast = index === discounts.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {code}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {`${persianNumberFormat(percentage)}%`}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(max_value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(max_value_usage, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {expiration_date && persianNumberFormat(expiration_date)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(type)}
                          color={type === "public" ? "green" : type === "service" ? "blue" : "purple"}/>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {admin_name}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip className="textRight" variant="ghost"
                          value={Dict(status)}
                          color={status === "enable" ? "green" : "red"}/>
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="عملیات">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setDiscount(discounts[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}